import {createFeatureSelector, createSelector} from '@ngrx/store';
import {CustomerStore} from './customer-store';

export const customerFeatureSelector = createFeatureSelector<CustomerStore>('customer');
export const customerSelector = createSelector(customerFeatureSelector, state => state.customers);
export const corporateCustomerSelector = createSelector(customerFeatureSelector, state => state.corporateCustomers);
